/**
 * A gentle one-line notice that outlives the composer that raised it — the
 * composer closes on a successful seal, the notice should not vanish with it.
 * One at a time; a new one replaces the old.
 */

type Listener = () => void;

let current: { id: number; text: string } | null = null;
let seq = 0;
const listeners = new Set<Listener>();

export const postageNotice = {
  show(text: string) {
    current = { id: ++seq, text };
    listeners.forEach((l) => l());
  },
  clear(id?: number) {
    if (id != null && current?.id !== id) return;
    current = null;
    listeners.forEach((l) => l());
  },
  get: () => current,
  subscribe(l: Listener) {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};

/** Copy for a seal that went on another class than the one asked for. */
export function downgradeNotice(asked: string | undefined, went: string): string {
  const label = went === 'first' ? '1st class' : '2nd class';
  return asked === 'express'
    ? `No Express stamp to hand just then, so it went ${label}.`
    : `1st class is paused for now, so it went ${label}.`;
}
